import * as React from "react";
import classnames from "classnames";
import { Heading, Text } from "@grandvisionhq/elements";
/* empty css                   */
const StoreOptician = ({
  name,
  details,
  imageUrl,
  fallbackImageUrl,
  className,
  ...rest
}) => {
  const sharedProps = {
    className: classnames("store-optician__image", {
      "store-optician__image--fallback": !imageUrl
    }),
    "data-t": "ImageContainer"
  };
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-optician", className) }, /* @__PURE__ */ React.createElement("div", { ...sharedProps }, /* @__PURE__ */ React.createElement("img", { src: imageUrl ?? fallbackImageUrl, "data-t": "Image", alt: name })), /* @__PURE__ */ React.createElement(Heading, { component: "h4", variant: "subheading1", className: "store-optician__name" }, name), details && /* @__PURE__ */ React.createElement(Text, { variant: "body", className: "store-optician__details" }, details));
};
export {
  StoreOptician as default
};
//# sourceMappingURL=StoreOptician.js.map
